<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations sur l'assurance</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div class="card__row" *ngIf="metadata?.type || originalMetadata?.type">
        <span class="card__label" i18n>Type</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getInsuranceTypeLabel(originalMetadata.type) !==
                  getInsuranceTypeLabel(metadata.type),
            }"
            >{{ getInsuranceTypeLabel(metadata.type) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getInsuranceTypeLabel(originalMetadata.type) !==
                getInsuranceTypeLabel(metadata.type) &&
              originalMetadata.type !== null &&
              originalMetadata.type !== undefined
            "
            >{{ getInsuranceTypeLabel(originalMetadata.type) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.startDate | customDate) !==
                  (metadata.startDate | customDate),
            }"
            >{{ metadata.startDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata.startDate | customDate) !==
                (metadata.startDate | customDate) &&
              originalMetadata.startDate !== null &&
              originalMetadata.startDate !== undefined
            "
            >{{ originalMetadata.startDate | customDate }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
